import React from 'react';

interface ErrorBoxProps {
  text: string;
  img?: string;
  className?: string;
}

const ErrorBox = ({ text, img, className }: ErrorBoxProps) => {
  return (
    <div className={`error-box ${className}`}>
      {img && <img src={img} alt="error" />}
      <span>
        {text}
      </span>
    </div>
  );
};

export default ErrorBox;